module.exports = __webpack_public_path__ + "static/Hummus.ca4bbcae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Hummus.jpg
// module id = 458
// module chunks = 35783957827783